/** Kanban of one parent’s subtree (or direct children when nested is hidden). */
export function parentSubtaskBoardPath(projectId: string, workItemId: string): string {
  return `/projects/${projectId}/work-items/${workItemId}/board`;
}

export function workItemHasSubtasks(item: { child_ids: string[] }): boolean {
  return item.child_ids.length > 0;
}
